
import SessionListElement from "@/model/SessionListElement";
import api from "@/service/api";
import Vue from "vue";
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
import SingleOrders, { OrderItem } from "./SingleOrders.vue";

@Component({
    components: {
        SingleOrders,
    },
})
export default class SessionOrdersWindow extends Vue {
    @Prop({
        type: Object,
        required: true,
    })
    session!: SessionListElement;

    orders: OrderItem[] = [];
    isLoading: boolean = true;

    async mounted() {
        try {
            this.orders = await api.getSessionOrders(this.session.id);
        } catch (error) {
            console.error('Error loading orders:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
